import { Link } from 'react-router-dom';
import fbInsightsLogo from '@/assets/logos/fbinsights/fb_insights_logo_white_red.png';
import StartFreeLink from '../../../components/StartFreeLink';

const CONTACT_EMAIL = import.meta.env.VITE_CONTACT_EMAIL || 'info@fbinsights.com';
const COMPANY_NAME = import.meta.env.VITE_COMPANY_NAME || 'F&B Insights';

const sectionLinks = [
  { href: '/#how-it-works', label: 'How It Works' },
  { href: '/#pricing', label: 'Pricing' },
  { href: '/#faq', label: 'FAQ' },
];

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-fb-navy text-white">
      <div className="mx-auto flex max-w-content flex-wrap items-center justify-between gap-5 border-t border-white/10 px-8 py-7">
        <img src={fbInsightsLogo} alt={COMPANY_NAME} className="h-6 w-auto" />

        <div className="flex flex-wrap items-center gap-x-6 gap-y-3 text-sm">
          {sectionLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="text-white/70 transition-colors hover:text-white"
            >
              {link.label}
            </a>
          ))}
          <StartFreeLink className="text-white/70 transition-colors hover:text-white">
            Start Free
          </StartFreeLink>
          <a
            href={`mailto:${CONTACT_EMAIL}`}
            className="text-white/70 transition-colors hover:text-white"
          >
            Contact Us
          </a>
          <Link to="/privacy-policy" className="text-white/70 transition-colors hover:text-white">
            Privacy Policy
          </Link>
          <Link to="/terms" className="text-white/70 transition-colors hover:text-white">
            Terms
          </Link>
        </div>

        <div className="text-sm text-white/45">
          © {year} {COMPANY_NAME}
        </div>
      </div>
    </footer>
  );
}
